webpackJsonp([1],{

/***/ "M4+w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tree"},[_c('h1',{staticClass:"title"},[_vm._v("Vue + D3 : 줌과 패닝이 가능한 Tree 그래프 그리기")]),_vm._v(" "),_c('svg',{ref:"svg",staticClass:"container",attrs:{"width":_vm.viewer.w,"height":_vm.viewer.h},on:{"click":_vm.setZoom}},[_c('g',{attrs:{"transform":("translate(" + (_vm.zoom.x) + "," + (_vm.zoom.y) + ")scale(" + (_vm.zoom.k) + ")")}},[_vm._l((_vm.lines),function(line){return _c('path',{staticClass:"link",attrs:{"d":_vm.getDiagonal(line)}})}),_vm._v(" "),_vm._l((_vm.nodes),function(node){return _c('g',{staticClass:"node",class:node.children ? 'node--internal' : 'node--leaf',attrs:{"transform":("translate(" + (node.y) + "," + (node.x) + ")")}},[_c('circle',{attrs:{"r":"2.5"}}),_vm._v(" "),_c('text',{style:({ textAnchor: node.children ? 'end' : 'start' }),attrs:{"dy":"3","x":node.children ? -8 : 8}},[_vm._v(_vm._s(node.data.name))])])})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a3f27a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("WyPT");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a3f27a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "WyPT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Tree')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZD/p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tree_vue__ = __webpack_require__("eeGr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_688e9074_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tree_vue__ = __webpack_require__("M4+w");
function injectStyle (ssrContext) {
  __webpack_require__("oVHT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tree_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_688e9074_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tree_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eeGr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__("vwbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data__ = __webpack_require__("vnjs");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tree',
  data: function data() {
    return {
      viewer: {
        w: 600,
        h: 600
      },
      nodes: [],
      lines: [],
      zoom: {
        x: 40,
        y: 0,
        k: 1
      }
    };
  },
  created: function created() {
    this.setData();
  },
  mounted: function mounted() {
    this.setZoom();
  },

  methods: {
    setData: function setData() {
      var stratify = __WEBPACK_IMPORTED_MODULE_0_d3__["c" /* stratify */]().id(function (d) {
        return d.id;
      }).parentId(function (d) {
        return d.parentId;
      });
      var stratified = stratify(__WEBPACK_IMPORTED_MODULE_1__data__["a" /* default */]);
      var tree = __WEBPACK_IMPORTED_MODULE_0_d3__["d" /* tree */]().size([this.viewer.w, this.viewer.h]);

      tree(stratified);
      this.nodes = stratified.descendants();
      this.lines = stratified.descendants().slice(1);
    },
    getDiagonal: function getDiagonal(d) {
      return 'M' + d.y + ',' + d.x + 'C' + (d.parent.y + 100) + ',' + d.x + ' ' + (d.parent.y + 100) + ',' + d.parent.x + ' ' + d.parent.y + ',' + d.parent.x;
    },
    setZoom: function setZoom() {
      var zoom = __WEBPACK_IMPORTED_MODULE_0_d3__["e" /* zoom */]().scaleExtent([1, 10]).on('zoom', this.onZoom);
      var selection = __WEBPACK_IMPORTED_MODULE_0_d3__["b" /* select */](this.$refs.svg);

      selection.call(zoom).call(zoom.transform, this.initZoom());
    },
    initZoom: function initZoom() {
      this.zoom.x = 40;
      this.zoom.y = 0;
      this.zoom.k = 1;

      return __WEBPACK_IMPORTED_MODULE_0_d3__["f" /* zoomIdentity */].translate(this.zoom.x, this.zoom.y).scale(this.zoom.k);
    },
    onZoom: function onZoom() {
      this.zoom.x = __WEBPACK_IMPORTED_MODULE_0_d3__["a" /* event */].transform.x;
      this.zoom.y = __WEBPACK_IMPORTED_MODULE_0_d3__["a" /* event */].transform.y;
      this.zoom.k = __WEBPACK_IMPORTED_MODULE_0_d3__["a" /* event */].transform.k;
    }
  }
});

/***/ }),

/***/ "oVHT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vnjs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var data = [{ id: 0, name: '속씨식물군', parentId: null }, { id: 1, name: '외떡잎식물아강', parentId: 0 }, { id: 2, name: '진정쌍떡잎식물아강', parentId: 0 }, { id: 3, name: '목련아강', parentId: 0 }, { id: 4, name: '백계피목', parentId: 3 }, { id: 5, name: '후추목', parentId: 3 }, { id: 6, name: '목련목', parentId: 3 }, { id: 7, name: '택사군', parentId: 1 }, { id: 8, name: '백합군', parentId: 1 }, { id: 9, name: '기저진정쌍떡잎식물군', parentId: 2 }, { id: 10, name: '핵심진정쌍떡잎식물군', parentId: 2 }, { id: 11, name: '미나리아재비목', parentId: 9 }, { id: 12, name: '프로테아목', parentId: 9 }, { id: 13, name: '수레나무목', parentId: 9 }, { id: 14, name: '장미군', parentId: 10 }, { id: 15, name: '국화군', parentId: 10 }, { id: 16, name: '이카키나목', parentId: 15 }, { id: 17, name: '용담목', parentId: 15 }, { id: 18, name: '가리야목', parentId: 15 }, { id: 19, name: '발리아목', parentId: 15 }, { id: 20, name: '가지목', parentId: 15 }, { id: 21, name: '꿀풀목', parentId: 15 }, { id: 22, name: '가지과', parentId: 20 }, { id: 23, name: '메꽃과', parentId: 20 }, { id: 24, name: '새삼과', parentId: 20 }, { id: 25, name: '레트지아과', parentId: 20 }, { id: 26, name: '조름나물과', parentId: 20 }, { id: 27, name: '흰독말풀', parentId: 22 }, { id: 28, name: '가지', parentId: 22 }, { id: 29, name: '맨드레이크', parentId: 22 }, { id: 30, name: '고추', parentId: 22 }, { id: 31, name: '감자', parentId: 22 }, { id: 32, name: '담배', parentId: 22 }, { id: 33, name: '토마토', parentId: 22 }];

/* harmony default export */ __webpack_exports__["a"] = (data);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Tree__ = __webpack_require__("ZD/p");
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: { Tree: __WEBPACK_IMPORTED_MODULE_0__components_Tree__["a" /* default */] }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.c772d539efdf2e2b32df.js